import useMarketplacesQuery from '../Queries/marketplacesQuery';
import useCurrentMasterCountry from './useCurrentMasterCountry';

export default function useMarketplacesForCurrentCountry() {
	const marketplacesQuery = useMarketplacesQuery();
	const currentMasterCountry = useCurrentMasterCountry();
	const countryId = currentMasterCountry?.id;

	const marketplacesForCurrentCountry = marketplacesQuery?.data?.filter(
		(m) => m.country_id === countryId
	);

	return marketplacesForCurrentCountry;
}
